import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { MISC_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class MiscService {
  static getSupportList = async filter => {
    try {
      const result = await HTTPHandler.post(
        `${MISC_API_URL}/support/list`,
        filter
      )

      return formatResponse(result)
    } catch (error) {
      return createError(error)
    }
  }

  static getSupportById = async id => {
    try {
      const result = await HTTPHandler.get(MISC_API_URL + '/support/' + id)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static updateSupportById = async data => {
    try {
      const result = await HTTPHandler.patch(MISC_API_URL + '/support', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static createSupport = async data => {
    try {
      const result = await HTTPHandler.post(`${MISC_API_URL}/support`, data)

      return formatResponse(result)
    } catch (error) {
      return createError(error)
    }
  }

  static supportQuestionnaire = async data => {
    try {
      const result = await HTTPHandler.post(
        MISC_API_URL + '/supportQuestionnaire/create',
        data
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static uploadPhoto = async data => {
    try {
      const result = await HTTPHandler.post(
        MISC_API_URL + '/files/uploadFile',
        data
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getCount = async data => {
    try {
      const result = await HTTPHandler.post(
        MISC_API_URL + '/support/countSupport',
        data
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
}
